(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-colors"] && !Shopify.designMode) return;
  try {
    if (!window.__productCardColorsBound) {
    window.__productCardColorsBound = true;

    var navigate = function (event) {
      var swatch = event.target.closest('.product-card__color-swatch');
      if (!swatch) return;
      var url = swatch.dataset.url;
      if (!url) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    };

    document.addEventListener('click', navigate);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var swatch = event.target.closest('.product-card__color-swatch');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      var url = swatch.dataset.url;
      if (url) window.location.href = url;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
